import * as React from 'react';
import Card from '@mui/material/Card';
import Icn from './Icn';
import IconBtn from './IconBtn';
import { colors } from '../maps/colors';
import Tx from './Tx';
import { api } from '../maps/data.js';
import { useEffect } from 'react';
import { useState } from 'react';
import InstallerAddSensorsToEdgeDialog from './dialogs/InstallerAddSensorsToEdgeDialog';
import SensorStatus from "./SensorStatus";
import useZibi from "../zibi/UseZibi";

export default function InstallerShelfCard(props) {

    const { edgeId, edge } = props;

    const [sensorStatuses] = useZibi('sensorStatuses');

    const [open_add_sensors_dialog, s_open_add_sensors_dialog] = useState(false);
    const [sensors, s_sensors] = useState([]);
    const [hover_sensor, s_hover_sensor] = useState(false)

    const installerId = zibi.user.installerId;

    const getSensors = async () => {
        const res = await api({ type: 'getSensors', data: { edgeId, type: 'step' } });
        s_sensors(res);
    }

    const removeSensorFromEdge = async (sensorId) => {
        // Check if the sensor bounded to floor
        const floor = edge?.floor?.floorEdgeSteps?.find(floorEdgeStep => {
            return floorEdgeStep?.sensorId === sensorId;
        })

        if (!floor) {
            await api({ type: 'removeSensorFromEdge', data: { edgeId, sensorId } });
            getSensors();
        } else {
            window.messageBox("Cold not remove the sensor because it is bounded to the edge, please first delete it from the edge and then try again.")
        }
    }

    useEffect(() => {
        getSensors();
    }, [edgeId]);

    return (
        <Card onClick={props.onClick} sx={{ width: '100%', marginBottom: '5px', background: props.selected ? colors.LIGHT_GREEN + "50" : 'white' }}>
            <div style={{ padding: 5 }}>
                <Icn style={{ position: 'relative', top: 4 }}>sensor</Icn> <span style={{ fontSize: 18, fontWeight: 500 }}><Tx>g.step</Tx></span>
                <div>
                    {
                        sensors.map(sensor => {
                            const sensorStatusData = sensorStatuses[sensor._id];
                            const status = sensorStatusData?.status;
                            const statusUpdateAt = sensorStatusData?.statusUpdateAt;
                            return (<div
                                onMouseEnter={() => s_hover_sensor(sensor._id)}
                                onMouseLeave={() => s_hover_sensor(false)}
                                key={sensor._id}
                                style={{ position: 'relative', padding: 3, minWidth: 100, border: `1px solid ${colors.GREEN}`, borderRadius: 3, color: colors.GREEN, fontWeight: 'bold', fontSize: 14, margin: 2, display: 'inline-block', textAlign: 'center' }}>
                                <SensorStatus status={status} statusUpdateAt={statusUpdateAt} />
                                {sensor.boardId}
                                {
                                    hover_sensor === sensor._id && <IconBtn onClick={() => removeSensorFromEdge(sensor._id)} style={{ position: 'absolute', top: -5, left: 30 }} size="small">delete</IconBtn>
                                }
                            </div>)
                        })
                    }
                </div>
            </div>
            <div style={{ padding: 5 }}>
                <IconBtn customtheme="small-gray" size="small" onClick={() => s_open_add_sensors_dialog(true)}>add</IconBtn>
            </div>
            {
                open_add_sensors_dialog && <InstallerAddSensorsToEdgeDialog type="step" edgeId={edgeId} installerId={installerId} onClose={() => {
                    s_open_add_sensors_dialog(false);
                    getSensors();
                }} />
            }
        </Card>
    );
}